import Constants from 'js/Constants';
import {
  StatusIconActive,
  StatusIconInit,
  StatusIconPaused,
  StatusIconRateLimited,
} from 'js/components/elements/icons/StatusIcons';

const statusInfo = {
  [Constants.SourceStatus.ACTIVE]: {
    name: 'Active',
    Icon: StatusIconActive,
    color: 'success',
  },
  [Constants.SourceStatus.PAUSED]: {
    name: 'Paused',
    Icon: StatusIconPaused,
    color: 'warning',
  },
  [Constants.SourceStatus.RATE_LIMITED]: {
    name: 'Billing Tier Limit Exceeded',
    Icon: StatusIconRateLimited,
    color: 'danger',
  },
  [Constants.SourceStatus.INIT]: {
    name: 'Initialized',
    Icon: StatusIconInit,
    color: 'primary',
  },
};

export function getStatusInfo(status) {
  return statusInfo[status] || statusInfo.INIT;
}
